/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_SubmitInputs */

const en_capture_submit = /** @type {(inputs: Capture_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create student & lesson`)
};

const he_capture_submit = /** @type {(inputs: Capture_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת תלמיד ושיעור`)
};

/**
* | output |
* | --- |
* | "Create student & lesson" |
*
* @param {Capture_SubmitInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_submit = /** @type {((inputs?: Capture_SubmitInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_SubmitInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_submit(inputs)
	return he_capture_submit(inputs)
});